import { ConnectWallet } from "./connect-wallet";
import { ConnectedFlow } from "./connected-flow";
import {
  connectedTrigger,
  ConnectedTrigger,
  ConnectedTriggerContent,
} from "./connected-trigger";
import { DisconnectedFlow } from "./disconnected-flow";
import {
  disconnectedTrigger,
  DisconnectedTrigger,
  DisconnectedTriggerContent,
} from "./disconnected-trigger";
import { popoverContent } from "./styles";

export const Wallet = {
  ConnectedFlow,
  connectedTrigger,
  ConnectedTrigger,
  ConnectedTriggerContent,
  DisconnectedFlow,
  disconnectedTrigger,
  DisconnectedTrigger,
  DisconnectedTriggerContent,
  popoverContent,
  ConnectWallet,
};
